import {
  ArrowBackOutlined,
  ArrowForwardOutlined,
  FitScreenOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutMapOutlined,
  ZoomOutOutlined,
} from '@mui/icons-material'
import { IconButton, Tooltip, Typography } from '@mui/material'
import { ZoomAndPanImgRef } from 'components/Images/ZoomAndPanImg'
import { MouseEventHandler } from 'react'
import { PdfViewerModel } from 'services/APIs/InternalAPI/internal-api.contracts'
import { makeStyles } from 'tss-react/mui'

type Props = {
  handlePrevClick: MouseEventHandler<HTMLButtonElement>
  currentDrawingIndex: number
  pdfViewModel: PdfViewerModel
  handleNextClick: MouseEventHandler<HTMLButtonElement>
  imgControllerRef: React.RefObject<ZoomAndPanImgRef>
  additionalComponents?: React.ReactNode
}

const useStyles = makeStyles({ name: 'carrousel-toolbox' })((theme) => ({
  imgToolbox: {
    position: 'absolute',
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    opacity: 0.8,
    color: theme.palette.getContrastText(theme.palette.background.paper),
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  imgCounter: {
    width: '100%',
    textAlign: 'center',
    // paddingLeft: theme.spacing(8),
    flexWrap: 'nowrap',
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imgTools: {
    display: 'flex',
    marginLeft: 'auto',
    paddingRight: theme.spacing(6),
  },
  additionalComponents: {
    display: 'flex',
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(6),
    width: theme.breakpoints.values.sm,
    minWidth: 0,
  },
}))

export const EngDrawingCarrouselToolbox = (props: Props) => {
  const { classes } = useStyles()

  return (
    <div className={classes.imgToolbox} onClick={(e) => e.stopPropagation()}>
      <div className={classes.additionalComponents}>
        {props.additionalComponents}
      </div>
      <div className={classes.imgCounter}>
        <IconButton
          size="small"
          onClick={props.handlePrevClick}
          color="inherit"
        >
          <ArrowBackOutlined fontSize="small" />
        </IconButton>
        <Typography variant="caption" fontWeight="bold" noWrap>
          {(props.currentDrawingIndex || 0) + 1} /{' '}
          {props.pdfViewModel?.pages?.length}
        </Typography>
        <IconButton
          component="button"
          size="small"
          onClick={props.handleNextClick}
          color="inherit"
        >
          <ArrowForwardOutlined fontSize="small" />
        </IconButton>
      </div>
      <div className={classes.imgTools}>
        <Tooltip title="zoom in">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              props.imgControllerRef.current?.zoomIn()
            }}
          >
            <ZoomInOutlined />
          </IconButton>
        </Tooltip>
        <Tooltip title="zoom out">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              props.imgControllerRef.current?.zoomOut()
            }}
          >
            <ZoomOutOutlined />
          </IconButton>
        </Tooltip>
        <Tooltip title="zoom to fit">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              props.imgControllerRef.current?.fitPage()
            }}
          >
            <FitScreenOutlined />
          </IconButton>
        </Tooltip>
        <Tooltip title="zoom 100%">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              props.imgControllerRef.current?.zoomToScale(1)
            }}
          >
            <ZoomOutMapOutlined />
          </IconButton>
        </Tooltip>

        <Tooltip title="rotate clockwise">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              props.imgControllerRef.current?.rotateImage('90deg')
            }}
          >
            <RotateRightOutlined />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  )
}
